@use '@dixa/lib-shared-tokens/scss' as *;

.root {
  display: flex;
  flex-direction: column;
  padding: var(--dixa-size-spacer-200) 0;
}

.main {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.content {
  display: flex;
  align-items: center;
  gap: var(--dixa-size-spacer-200);
  flex: 0.95;
  word-break: break-all;
  color: var(--dixa-color-neutral-800);
}

.iconContainer {
  @include flex-centered();
  z-index: 1;
  background-color: var(--dixa-color-neutral-100);
  border-radius: 16px;
  min-width: var(--dixa-size-spacer-400);
  height: var(--dixa-size-spacer-400);
}

.text {
  padding-top: 2px;
  &::first-letter {
    text-transform: uppercase;
  }
}

.message {
  margin: var(--dixa-size-spacer-300) 0 var(--dixa-size-spacer-300)
    var(--dixa-size-spacer-500);
}

.codeHighlight {
  max-height: 500px;
  border: none;
}
